import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'
import Notification from '@stimulus-components/notification'

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

application.register('notification', Notification)

import PopoverController from './controllers/home/popover-controller'
application.register('popover', PopoverController)
